var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLossAversionGauge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 410.792,
    height: 279.612,
    viewBox: "0 0 410.792 279.612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .loss-cls-1 {\n        fill: #edf1fe;\n      }\n\n      .loss-cls-2, .loss-cls-3, .loss-cls-4, .loss-cls-7 {\n        fill: #262626;\n      }\n\n      .loss-cls-2 {\n        font-size: 10px;\n      }\n\n      .loss-cls-2, .loss-cls-3, .loss-cls-4 {\n        font-family: Montserrat-Bold, Montserrat;\n        font-weight: 700;\n      }\n\n      .loss-cls-3 {\n        font-size: 11px;\n      }\n\n      .loss-cls-4 {\n        font-size: 8px;\n      }\n\n      .loss-cls-5 {\n        fill: #cce;\n      }\n\n      .loss-cls-6 {\n        fill: #fff;\n      }\n\n      .loss-cls-8 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3904",
    name: "Group 3904",
    transform: "translate(-60 -846.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3849",
    name: "Group 3849",
    transform: "translate(60 845.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3847",
    name: "Group 3847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3902",
    name: "Group 3902"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5606",
    name: "Path 5606",
    className: "loss-cls-1",
    d: "M205.4.223c113.437,0,205.4,91.959,205.4,205.4-.232-.263-410.5-.263-410.792,0C0,92.182,91.959.223,205.4.223",
    transform: "translate(0 -0.034)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "H",
    className: "loss-cls-2",
    transform: "translate(19.971 189.398) rotate(-83.543)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H")), /*#__PURE__*/React.createElement("text", {
    id: "I",
    className: "loss-cls-2",
    transform: "translate(21.199 179.173) rotate(-81.277)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    id: "G",
    className: "loss-cls-3",
    transform: "translate(22.842 174.811) rotate(-79.065)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G")), /*#__PURE__*/React.createElement("text", {
    id: "H-2",
    name: "H",
    className: "loss-cls-2",
    transform: "translate(23.743 164.944) rotate(-75.963)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H")), /*#__PURE__*/React.createElement("text", {
    id: "_",
    name: " ",
    className: "loss-cls-4",
    transform: "translate(24.387 154.43) rotate(-73.749)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "C",
    className: "loss-cls-2",
    transform: "translate(27.413 151.068) rotate(-71.66)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C")), /*#__PURE__*/React.createElement("text", {
    id: "O",
    className: "loss-cls-3",
    transform: "matrix(0.365, -0.931, 0.931, 0.365, 31.244, 142.673)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "M",
    className: "loss-cls-2",
    transform: "matrix(0.422, -0.907, 0.907, 0.422, 34.224, 132.336)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    id: "F",
    className: "loss-cls-2",
    transform: "translate(39.366 121.445) rotate(-61.914)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F")), /*#__PURE__*/React.createElement("text", {
    id: "O-2",
    name: "O",
    className: "loss-cls-3",
    transform: "translate(44.071 114.718) rotate(-59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "R",
    className: "loss-cls-2",
    transform: "matrix(0.561, -0.828, 0.828, 0.561, 48.764, 105.035)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("text", {
    id: "T",
    className: "loss-cls-2",
    transform: "translate(54.02 97.329) rotate(-53.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    name: " ",
    className: "loss-cls-4",
    transform: "translate(57.3 89.675) rotate(-51.372)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "W",
    className: "loss-cls-3",
    transform: "matrix(0.662, -0.749, 0.749, 0.662, 62.063, 88.335)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W")), /*#__PURE__*/React.createElement("text", {
    id: "I-2",
    name: "I",
    className: "loss-cls-2",
    transform: "translate(70.898 77.041) rotate(-45.649)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    id: "T-2",
    name: "T",
    className: "loss-cls-2",
    transform: "translate(74.099 73.741) rotate(-43.715)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    id: "H-3",
    name: "H",
    className: "loss-cls-2",
    transform: "matrix(0.756, -0.655, 0.655, 0.756, 79.909, 68.172)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H")), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    name: " ",
    className: "loss-cls-4",
    transform: "matrix(0.78, -0.625, 0.625, 0.78, 86.491, 59.922)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "D",
    className: "loss-cls-3",
    transform: "translate(91.481 59.703) rotate(-36.477)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D")), /*#__PURE__*/React.createElement("text", {
    id: "R-2",
    name: "R",
    className: "loss-cls-2",
    transform: "translate(99.34 52.69) rotate(-33.43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("text", {
    id: "A",
    className: "loss-cls-2",
    transform: "matrix(0.862, -0.507, 0.507, 0.862, 107.23, 47.499)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    id: "W-2",
    name: "W",
    className: "loss-cls-3",
    transform: "translate(115.7 43.595) rotate(-26.882)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W")), /*#__PURE__*/React.createElement("text", {
    id: "D-2",
    name: "D",
    className: "loss-cls-3",
    transform: "translate(128.456 37.22) rotate(-23.083)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D")), /*#__PURE__*/React.createElement("text", {
    id: "O-3",
    name: "O",
    className: "loss-cls-3",
    transform: "translate(138.072 33.138) rotate(-19.804)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "W-3",
    name: "W",
    className: "loss-cls-3",
    transform: "translate(147.828 29.571) rotate(-15.98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W")), /*#__PURE__*/React.createElement("text", {
    id: "N",
    className: "loss-cls-2",
    transform: "translate(161.354 24.748) rotate(-12.188)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N")), /*#__PURE__*/React.createElement("text", {
    id: "S",
    className: "loss-cls-2",
    transform: "translate(171.413 22.62) rotate(-9.311)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("text", {
    id: "L",
    className: "loss-cls-2",
    transform: "translate(231.293 21.237) rotate(9.037)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    id: "O-4",
    name: "O",
    className: "loss-cls-3",
    transform: "matrix(0.979, 0.206, -0.206, 0.979, 238.724, 23.41)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "W-4",
    name: "W",
    className: "loss-cls-3",
    transform: "translate(248.896 25.497) rotate(15.706)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W")), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    name: " ",
    className: "loss-cls-4",
    transform: "translate(263.73 26.709) rotate(18.584)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "C-2",
    name: "C",
    className: "loss-cls-2",
    transform: "translate(266.952 29.866) rotate(20.667)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C")), /*#__PURE__*/React.createElement("text", {
    id: "O-5",
    name: "O",
    className: "loss-cls-3",
    transform: "translate(275.18 34.032) rotate(23.718)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "M-2",
    name: "M",
    className: "loss-cls-2",
    transform: "translate(285.392 37.428) rotate(27.222)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    id: "F-2",
    name: "F",
    className: "loss-cls-2",
    transform: "translate(296.07 43) rotate(30.348)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F")), /*#__PURE__*/React.createElement("text", {
    id: "O-6",
    name: "O",
    className: "loss-cls-3",
    transform: "translate(302.61 47.969) rotate(33.237)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "R-3",
    name: "R",
    className: "loss-cls-2",
    transform: "matrix(0.806, 0.592, -0.592, 0.806, 312.102, 53.038)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("text", {
    id: "T-3",
    name: "T",
    className: "loss-cls-2",
    transform: "translate(319.587 58.575) rotate(38.959)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    id: "_5",
    name: " ",
    className: "loss-cls-4",
    transform: "translate(327.117 62.151) rotate(40.811)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "W-5",
    name: "W",
    className: "loss-cls-3",
    transform: "translate(328.268 66.958) rotate(43.651)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W")), /*#__PURE__*/React.createElement("text", {
    id: "I-3",
    name: "I",
    className: "loss-cls-2",
    transform: "translate(339.239 76.234) rotate(46.527)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")), /*#__PURE__*/React.createElement("text", {
    id: "T-4",
    name: "T",
    className: "loss-cls-2",
    transform: "matrix(0.663, 0.748, -0.748, 0.663, 342.406, 79.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    id: "H-4",
    name: "H",
    className: "loss-cls-2",
    transform: "matrix(0.626, 0.78, -0.78, 0.626, 347.757, 85.573)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H")), /*#__PURE__*/React.createElement("text", {
    id: "_6",
    name: " ",
    className: "loss-cls-4",
    transform: "translate(355.736 92.448) rotate(53.484)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    id: "D-3",
    name: "D",
    className: "loss-cls-3",
    transform: "matrix(0.563, 0.826, -0.826, 0.563, 355.76, 97.437)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D")), /*#__PURE__*/React.createElement("text", {
    id: "R-4",
    name: "R",
    className: "loss-cls-2",
    transform: "matrix(0.518, 0.855, -0.855, 0.518, 362.472, 105.57)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("text", {
    id: "A-2",
    name: "A",
    className: "loss-cls-2",
    transform: "translate(367.343 113.64) rotate(61.777)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    id: "W-6",
    name: "W",
    className: "loss-cls-3",
    transform: "translate(370.92 122.274) rotate(65.409)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W")), /*#__PURE__*/React.createElement("text", {
    id: "D-4",
    name: "D",
    className: "loss-cls-3",
    transform: "translate(376.779 135.276) rotate(69.234)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "D")), /*#__PURE__*/React.createElement("text", {
    id: "O-7",
    name: "O",
    className: "loss-cls-3",
    transform: "translate(380.466 145.044) rotate(72.522)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "W-7",
    name: "W",
    className: "loss-cls-3",
    transform: "translate(383.632 154.927) rotate(76.335)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W")), /*#__PURE__*/React.createElement("text", {
    id: "N-2",
    name: "N",
    className: "loss-cls-2",
    transform: "translate(387.906 168.643) rotate(80.094)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N")), /*#__PURE__*/React.createElement("text", {
    id: "S-2",
    name: "S",
    className: "loss-cls-2",
    transform: "matrix(0.123, 0.992, -0.992, 0.123, 389.635, 178.789)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3850",
    name: "Group 3850",
    transform: "translate(89.667 876.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5595",
    name: "Path 5595",
    className: "loss-cls-5",
    d: "M164.772,175.073,252.464,23.187a175.256,175.256,0,0,0-175.1.5Z",
    transform: "translate(9.738 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5595_-_Outline",
    name: "Path 5595 - Outline",
    className: "loss-cls-6",
    d: "M164.772,178.073,75.32,23.139l1.291-.752a176.451,176.451,0,0,1,176.6-.5l1.3.749ZM79.415,24.233l85.357,147.841L250.41,23.744a173.449,173.449,0,0,0-170.995.488Z",
    transform: "translate(9.738 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5596",
    name: "Path 5596",
    className: "loss-cls-5",
    d: "M330.636,172.465A174.6,174.6,0,0,0,243.3,20.492L155,172.465Z",
    transform: "translate(19.51 3.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5596_-_Outline",
    name: "Path 5596 - Outline",
    className: "loss-cls-6",
    d: "M332.136,173.965H152.394L242.757,18.448l1.294.744a175.693,175.693,0,0,1,81.777,105.972,179.426,179.426,0,0,1,6.308,47.3Zm-174.53-3H329.13a176.312,176.312,0,0,0-6.2-45.011A172.547,172.547,0,0,0,243.847,22.542Z",
    transform: "translate(19.51 3.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5597",
    name: "Path 5597",
    className: "loss-cls-5",
    d: "M87.1,21.035A174.991,174.991,0,0,0,0,172.426H174.51Z",
    transform: "translate(0 2.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5597_-_Outline",
    name: "Path 5597 - Outline",
    className: "loss-cls-6",
    d: "M87.651,18.981l89.458,154.945H-1.5v-1.5A176.779,176.779,0,0,1,86.349,19.739Zm84.262,151.945L86.561,23.095A173.237,173.237,0,0,0,1.506,170.926Z",
    transform: "translate(0 2.648)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    className: "loss-cls-6",
    cx: 73.5,
    cy: 73.5,
    r: 73.5,
    transform: "translate(191 978.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5638",
    name: "Path 5638",
    className: "loss-cls-7",
    d: "M-18.288,0V-11.2h2.144l4.768,7.9h-1.136l4.688-7.9H-5.7L-5.664,0H-8.1l-.016-7.472h.448l-3.744,6.288h-1.168L-16.4-7.472h.544V0ZM-.624-6.688H4.768v2.016H-.624ZM-.432-2.08h6.1V0H-3.008V-11.2H5.456v2.08H-.432ZM7.728,0V-11.2h5.088a7.1,7.1,0,0,1,3.216.7A5.313,5.313,0,0,1,18.208-8.56a5.449,5.449,0,0,1,.784,2.96,5.459,5.459,0,0,1-.784,2.952A5.294,5.294,0,0,1,16.032-.7a7.1,7.1,0,0,1-3.216.7ZM10.32-2.128h2.368a4.2,4.2,0,0,0,1.944-.424,3.075,3.075,0,0,0,1.28-1.208,3.6,3.6,0,0,0,.456-1.84,3.584,3.584,0,0,0-.456-1.848,3.09,3.09,0,0,0-1.28-1.2,4.2,4.2,0,0,0-1.944-.424H10.32Z",
    transform: "translate(264 933.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5637",
    name: "Path 5637",
    className: "loss-cls-7",
    d: "M-19.28,0V-11.2h2.592v9.088h5.616V0ZM-4.368.192A6.811,6.811,0,0,1-6.824-.24,5.811,5.811,0,0,1-8.776-1.456a5.549,5.549,0,0,1-1.28-1.84,5.75,5.75,0,0,1-.456-2.3,5.75,5.75,0,0,1,.456-2.3,5.494,5.494,0,0,1,1.288-1.84A5.918,5.918,0,0,1-6.816-10.96a6.7,6.7,0,0,1,2.432-.432,6.683,6.683,0,0,1,2.44.432A5.847,5.847,0,0,1-.008-9.744,5.674,5.674,0,0,1,1.28-7.912,5.648,5.648,0,0,1,1.744-5.6,5.72,5.72,0,0,1,1.28-3.288,5.54,5.54,0,0,1-.008-1.448,5.915,5.915,0,0,1-1.944-.24,6.638,6.638,0,0,1-4.368.192Zm-.016-2.208A3.653,3.653,0,0,0-3-2.272a3.319,3.319,0,0,0,1.112-.736,3.361,3.361,0,0,0,.744-1.136A3.867,3.867,0,0,0-.88-5.6a3.867,3.867,0,0,0-.264-1.456A3.423,3.423,0,0,0-1.88-8.192a3.216,3.216,0,0,0-1.112-.736,3.714,3.714,0,0,0-1.392-.256,3.653,3.653,0,0,0-1.384.256,3.319,3.319,0,0,0-1.112.736,3.361,3.361,0,0,0-.744,1.136A3.867,3.867,0,0,0-7.888-5.6a3.884,3.884,0,0,0,.264,1.448,3.4,3.4,0,0,0,.736,1.144,3.216,3.216,0,0,0,1.112.736A3.714,3.714,0,0,0-4.384-2.016ZM6.016,0,2.352-11.2H5.04L8.224-1.28H6.88l3.328-9.92h2.4l3.2,9.92h-1.3l3.264-9.92h2.48L16.592,0H13.808L10.976-8.7h.736L8.8,0Z",
    transform: "translate(158 983.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5639",
    name: "Path 5639",
    className: "loss-cls-7",
    d: "M-12.712-11.2h2.592V0h-2.592ZM-17.8,0h-2.592V-11.2H-17.8Zm5.28-4.592h-5.472V-6.784h5.472ZM-7.464,0V-11.2h2.592V0ZM3.192.192A6.8,6.8,0,0,1,.752-.232,5.743,5.743,0,0,1-1.184-1.44a5.549,5.549,0,0,1-1.28-1.84A5.791,5.791,0,0,1-2.92-5.6a5.791,5.791,0,0,1,.456-2.32A5.494,5.494,0,0,1-1.176-9.76,5.813,5.813,0,0,1,.776-10.968a6.908,6.908,0,0,1,2.464-.424,6.917,6.917,0,0,1,2.68.5,5.307,5.307,0,0,1,2.008,1.44L6.264-7.92a4.061,4.061,0,0,0-1.328-.952,3.9,3.9,0,0,0-1.568-.312,4.15,4.15,0,0,0-1.488.256,3.315,3.315,0,0,0-1.16.736A3.3,3.3,0,0,0-.032-7.056,3.867,3.867,0,0,0-.3-5.6,3.823,3.823,0,0,0-.032-4.16,3.388,3.388,0,0,0,.72-3.016a3.274,3.274,0,0,0,1.152.744,4.038,4.038,0,0,0,1.464.256,4.608,4.608,0,0,0,1.5-.248A4.317,4.317,0,0,0,6.248-3.1L7.72-1.232A6.751,6.751,0,0,1,5.6-.176,8.227,8.227,0,0,1,3.192.192Zm2.16-1.76V-5.776H7.72v4.544ZM17.8-11.2h2.592V0H17.8ZM12.712,0H10.12V-11.2h2.592Zm5.28-4.592H12.52V-6.784h5.472Z",
    transform: "translate(370 983.613)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2732",
    name: "Rectangle 2732",
    className: "loss-cls-8",
    width: 169.048,
    height: 116.534,
    transform: "translate(180.609 947.531)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossAversionGauge);
export default __webpack_public_path__ + "static/media/LossAversionGauge.82f0cf572ba2cb0f3634f809d26b7d89.svg";
export { ForwardRef as ReactComponent };